/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator';
import { Logger } from '@aws-amplify/core';

const logger = new Logger('SWUpdate');

@Component
export default class UpdateMixIn extends Vue {
  refreshing = false;
  registration: any = null;
  updateExists = false;

  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, {
      once: true
    });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      //localStorage.removeItem('vuex');
      window.location.reload();
    });
    logger.info('Added Update Listener');
  }

  // Store the SW registration so we can send it a message
  // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
  // To alert the user there is an update they need to refresh for
  updateAvailable(event: any) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  // Called when the user accepts the update
  refreshApp() {
    if (this.registration == null) return;
    this.updateExists = false;
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!this.registration || !this.registration.waiting) return;
    // send message to SW to skip the waiting and activate the new SW
    localStorage.removeItem('vuex');
    this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}
